import { contentLabelsSelector } from "@/redux/loadedContent/loadedContentSlice";
import { useState } from "react";
import { useSelector } from "react-redux";

import { ClearButton } from "../../../../atoms/ClearButton/ClearButton";
import { Position } from "../../../../molecules/Player/SquadBuilderPlayer/Position/Position";
import { PlayerPlaceHolder } from "../../../../molecules/PlayerPlaceHolder/PlayerPlaceHolder";
import { FilterButton } from "../FilterButton/FilterButton";
import { PlayerSidePanel } from "../PlayerSidePanel/PlayerSidePanel";

type Props = {
  isOverItem?: boolean;
  // Also the hover menu's Insert
  onClickPlayerPlaceHolder?: () => void;
  onClickFilter?: () => void;
  // Hover only, so phones never get it
  onClickRole?: () => void;
  onClickRemove?: () => void;
  activePlayerPlaceHolder?: boolean;
  formationPosition?: string;
  numberOfFilters?: number;
  disablePlayerFilters?: boolean;
  isOnBench?: boolean;
  tabletOrLargerMode?: boolean;
};

export const PitchItem = ({
  isOverItem,
  onClickPlayerPlaceHolder,
  onClickRemove,
  onClickFilter,
  onClickRole,
  activePlayerPlaceHolder,
  formationPosition,
  numberOfFilters,
  disablePlayerFilters,
  tabletOrLargerMode,
}: Props) => {
  const [onHover, setOnHover] = useState(false);
  const { positions } = useSelector(contentLabelsSelector);
  const filtersHandler = disablePlayerFilters ? undefined : onClickFilter;
  return (
    <div className="relative flex flex-col items-center px-2 touch-device:gap-y-1">
      <div className="relative flex flex-row items-center gap-x-2 w-fit">
        {/* Only the card and its menu count as hover, not the filter button */}
        <div
          onMouseEnter={() => tabletOrLargerMode && setOnHover(true)}
          onMouseLeave={() => tabletOrLargerMode && setOnHover(false)}
        >
          <PlayerPlaceHolder
            onClick={onClickPlayerPlaceHolder}
            activePlayerPlaceHolder={activePlayerPlaceHolder || isOverItem}
            tabletOrLargerMode={tabletOrLargerMode}
          />
          {/* Hover gets a filled card's menu; pl-2 bridges the gap to it */}
          {onHover &&
            (onClickPlayerPlaceHolder || filtersHandler || onClickRole) && (
              <div className="absolute top-1/2 -translate-y-1/2 left-full pl-2">
                <PlayerSidePanel
                  onClickInsert={onClickPlayerPlaceHolder}
                  onClickRole={onClickRole}
                  onClickFilters={filtersHandler}
                  numberOfFilters={numberOfFilters}
                />
              </div>
            )}
          {onClickRemove && onHover && (
            <div className="absolute z-10 -right-[14px] -top-[12px] scale-110">
              <ClearButton onClick={onClickRemove} />
            </div>
          )}
        </div>
        {/* The menu covers this spot and lists Filters with the count */}
        {!onHover && numberOfFilters > 0 && filtersHandler && (
          <div className="absolute -right-9">
            <FilterButton
              onClick={filtersHandler}
              numberOfFilters={numberOfFilters}
            />
          </div>
        )}
      </div>
      {formationPosition && (
        <div className="absolute bottom-[-12px] desktop:bottom-[-24px] large-desktop:bottom-[-24px] z-[-1] flex items-center justify-center inset-x-0">
          <Position tabletOrLargerMode={tabletOrLargerMode}>
            {positions[formationPosition]?.name ?? formationPosition}
          </Position>
        </div>
      )}
    </div>
  );
};
